import { render, staticRenderFns } from "./activityEditSemesterClassteacher.html?vue&type=template&id=6f72a18b&scoped=true&external"
import script from "./activityEditSemesterClassteacher.vue?vue&type=script&lang=js"
export * from "./activityEditSemesterClassteacher.vue?vue&type=script&lang=js"
import style0 from "./activityEditSemesterClassteacher.css?vue&type=style&index=0&id=6f72a18b&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f72a18b",
  null
  
)

export default component.exports